import { OverflowTooltip } from '../../apps/professional-app/fa/common/OverflowTooltip/OverflowTooltip'
import { Stack } from 'react-bootstrap'
import React from 'react'
import { useAppSelector } from '../../store/hooks'
import { selectSafeAuthenticatedUser } from '../../store/auth/authSlice'

export interface MeetingCreatorDisplayProps {
  creatorId?: string
  userLabels: { id: string; label: string }[]
}

export const MeetingCreatorDisplay: React.FC<MeetingCreatorDisplayProps> = ({ creatorId, userLabels }) => {
  const { id: currentUserId } = useAppSelector(selectSafeAuthenticatedUser)

  return (
    <Stack direction='horizontal' gap={2}>
      <i className='bi bi-person-fill icon' />
      <OverflowTooltip>
        <span className='paragraph-small'>{creatorId === currentUserId ? 'Me' : userLabels.find((u) => u.id === creatorId)?.label || '-'}</span>
      </OverflowTooltip>
    </Stack>
  )
}
